/**
 * The browser locale's first day of the week, 1 (Monday) to 7 (Sunday). Sunday when the browser can't tell.
 */
export default function browserFirstDayOfWeek(): number {
  try {
    const locale: any = new Intl.Locale(navigator.language)
    const weekInfo = locale.getWeekInfo ? locale.getWeekInfo() : locale.weekInfo
    return (weekInfo && weekInfo.firstDay) || 7
  } catch (e) {
    return 7
  }
}
